import React, { useEffect, useState } from "react";
import "../Transport Account/LogisticsHomepage.css";
import axios from 'axios';
import { TransportAdmi } from "./TransportAdminContext";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDateRange } from "react-icons/md";

const LogisticsAdminHomepage = () => {
  const { TransportAdminDetails, updateTransportAdminDetails } = TransportAdmi();
  const navigate = useNavigate();
const location=useLocation();
  // State for dashboard counts
  const [pendingJobsCount, setPendingJobsCount] = useState(0);
  const [activeJobsCount, setActiveJobsCount] = useState(0);
  const [completedJobsCount, setCompletedJobsCount] = useState(0);
  const [registeredClientsCount, setRegisteredClientsCount] = useState(0);
  const [loading, setLoading] = useState(true);
const [logos, setLogosCount] = useState(0);
  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const response = await axios.get("https://zoomautos.co.uk/api/logos",{
                params: {
          _t: new Date().getTime(), // Add timestamp to bypass cache
        },
      
      });
        setLogosCount(response.data.length);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching logos:", error);
        setLoading(false);
      }
    };

    fetchLogos();
  }, [location]);
  const token = sessionStorage.getItem("Transport Admin AuthToken");
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch jobs and clients data
        const jobsResponse = await axios.get("https://zoomautos.co.uk/api/Subcontract",  {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in headers
        },
          params: { _t: new Date().getTime() } // Add timestamp to bypass cache
      } );
        
        const clientsResponse = await axios.get("https://zoomautos.co.uk/api/Signup"
        ,{  params: { _t: new Date().getTime() } // Add timestamp to bypass cache
      } 
        );
          
        const jobsData = jobsResponse.data;
        console.log("Jobs Data:", jobsResponse.data);
        
        // Calculate counts for jobs
        const pendingJobs = jobsData.filter((job) => job.status === "pending").length;
        const activeJobs = jobsData.filter((job) => job.status === "Active").length;
        const completedJobs = jobsData.filter((job) => job.status === "Completed"||job.status === "Aborted").length;
  
        // Calculate count for registered clients
        
        // Set counts
        setPendingJobsCount(pendingJobs);
        setActiveJobsCount(activeJobs);
        setCompletedJobsCount(completedJobs);
        console.log(clientsResponse.length);
        setRegisteredClientsCount(clientsResponse.data.length);
        
        // Log data for debugging
        console.log("Pending Jobs:", pendingJobs);
        console.log("Active Jobs:", activeJobs);
        console.log("Completed Jobs:", completedJobs);
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
  
    fetchData();
  }, [location]);
  useEffect(() => {
    const storedUser = localStorage.getItem("TransportData");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      console.log("Retrieved user from localStorage:", user);
      updateTransportAdminDetails(user);
    } else {
      console.log("No TransportData found in localStorage.");
    }
  }, []); // Empty dependency array
  // Navigation functions
  const openCompletedJobs = () => {
    navigate("/Logistics/AdminPortal/Completed");
  };

  const openPendingJobs = () => {
    navigate("/Logistics/AdminPortal/Pending");
  };

  const openActiveJobs = () => {
    navigate("/Logistics/AdminPortal/Active");
  };

  const openRegisteredClients = () => {
    navigate("/Logistics/AdminPortal/RegisteredCustomers");
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="logisticshomepage-wrapper">
      {/* <img
        src={backgroundImage}
        alt="Logistics Background"
        className="background-image"
      /> */}


      {/* Dashboard Cards */}
      <div className="dashboard">
      <div className="headerlogistic">
        <h1 >Welcome {TransportAdminDetails?.username || "Admin"}</h1>
        <span className="date"><MdDateRange/> {new Date().toDateString()}</span>
      </div>
      </div>
      
        <div className="cardsdash2-container">
          {/* Pending Jobs Card */}
          <div
            className="carddash"
             
            onClick={openPendingJobs}
          >
            <h2>Pending Jobs</h2>
            <p>{pendingJobsCount}</p>
          </div>

          {/* Active Jobs Card */}
          <div
            className="carddash"
            
            onClick={openActiveJobs}
          >
            <h2>Active Jobs</h2>
            <p>{activeJobsCount}</p>
          </div>

          {/* Completed Jobs Card */}
          <div
            className="carddash"
            
            onClick={openCompletedJobs}
          >
            <h2>Completed Jobs</h2>
            <p>{completedJobsCount}</p>
          </div>

          {/* Registered Clients Card */}
          <div
            className="carddash"
            
            onClick={openRegisteredClients}
          >
            <h2>Registered Clients</h2>
            <p>{registeredClientsCount}</p>
          </div>
          <div
            className="carddash"
            
            onClick={openRegisteredClients}
          >
            <h2>Add Logos</h2>
            <p>{logos}</p>
          </div>
        </div>
        </div>
      
    
  );
};

export default LogisticsAdminHomepage;